<template>
  <div>
    <link
      href="https://fonts.googleapis.com/css2?family=Turret+Road:wght@500;700&display=swap"
      rel="stylesheet"
    />
    <div class="container">
      <div class="wrapper">
        <div class="flexbox">
          <div class="title"  >Stats</div>
          <img src="../assets/stats.gif" alt="" />
        </div>

        <div class="gridbox" >
           <div class="box" data-aos="fade-up" data-aos-duration="1000">
          <div class="title1">Total Supply</div>
          <div class="content">{{totalSupply}}</div>
        </div>

        <div class="box" data-aos="fade-down" data-aos-duration="1000">
          <div class="title1">Total Taxed</div>
          <div class="content">{{burned}}</div>
        </div>

         <div class="box" data-aos="fade-up" data-aos-duration="1000">
          <div class="title1">Cool Down Timer</div>
          <div class="content" v-if="time">{{cooldown}}</div>
          <div class="content" v-if="timeStatus">{{timeStatus}}</div>
        </div>

         <div class="box" data-aos="fade-down" data-aos-duration="1000">
          <div class="title1">Game Status</div>
          <div class="content">{{status}}</div>
        </div>
      </div>

      <div class="div" v-if="time">
        {{startTimer()}}
      </div>

      
       
      </div>
    </div>
  </div>
</template>

<script>
import Web3 from "web3";

export default {
  data() {
    return {
      hodlABI: [
        { inputs: [], stateMutability: "nonpayable", type: "constructor" },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "owner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "spender",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "value",
              type: "uint256",
            },
          ],
          name: "Approval",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: false,
              internalType: "uint256",
              name: "oldCoolDownTime",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "newCoolDownTime",
              type: "uint256",
            },
          ],
          name: "ChangeCoolDownTime",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: false,
              internalType: "uint256",
              name: "oldPercentile",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "newPercentile",
              type: "uint256",
            },
          ],
          name: "ChangeStrongHandPercentile",
          type: "event",
        },
        { anonymous: false, inputs: [], name: "EndGame", type: "event" },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "previousOwner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "newOwner",
              type: "address",
            },
          ],
          name: "OwnershipTransferred",
          type: "event",
        },
        { anonymous: false, inputs: [], name: "StartGame", type: "event" },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "from",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "to",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "value",
              type: "uint256",
            },
          ],
          name: "Transfer",
          type: "event",
        },
        {
          inputs: [],
          name: "_burnedSupply",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_coolDownTime",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_gameStarted",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_lastUpdated",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_strongHandPercentile",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "owner", type: "address" },
            { internalType: "address", name: "spender", type: "address" },
          ],
          name: "allowance",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "approve",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "account", type: "address" },
          ],
          name: "balanceOf",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "decimals",
          outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            {
              internalType: "uint256",
              name: "subtractedValue",
              type: "uint256",
            },
          ],
          name: "decreaseAllowance",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "endGame",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "addedValue", type: "uint256" },
          ],
          name: "increaseAllowance",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "name",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "owner",
          outputs: [{ internalType: "address", name: "", type: "address" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "renounceOwnership",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "uint256", name: "coolDownTime", type: "uint256" },
          ],
          name: "setCoolDownTime",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "uint256", name: "percentile", type: "uint256" },
          ],
          name: "setStrongHandPercentile",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "startGame",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "symbol",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "totalSupply",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "recipient", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "transfer",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "sender", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "transferFrom",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "newOwner", type: "address" },
          ],
          name: "transferOwnership",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
      ],
      hodlAddy: "0x9B574599822642B04d0fF7e5776dF3A06f4540ba",
      totalSupply: "",
      burned: "",
      status: '',
      time: '',
      cooldown: '',
      timeStatus: '',
    };
  },
  methods: {
    startTimer() {
      setInterval(() => {
        let todayDate = new Date();
      let epochNow = todayDate.getTime()/1000.0;
      let seconds = (12*3600 - (epochNow - this.time));
      this.cooldown = new Date(seconds * 1000).toISOString().substr(11, 8);
      }, 1000);
    },
  },
  async mounted() {
    const web3 = new Web3(new Web3.providers.HttpProvider('https://mainnet.infura.io/v3/dc3b6a24949844be8f83014cfba7483c'));
    const contract = new web3.eth.Contract(this.hodlABI, this.hodlAddy);

    let totalSupply = await contract.methods.totalSupply().call().then();
    let burned = await contract.methods._burnedSupply().call().then();
    let status = await contract.methods._gameStarted().call().then();
    let time = await contract.methods._lastUpdated().call().then();

    this.totalSupply = (totalSupply / (10**18).toFixed(0));
    this.burned = (burned / (10**18)).toFixed(2);

    let todayDate = new Date();
    let epochNow = todayDate.getTime()/1000.0;
    let difference = epochNow - time;

    if (difference < 43200) {
      this.time = time;
    } else {
      this.timeStatus = 'Ready'
    }
    

    if (status == true) {
      this.status = 'ON'
    } else {
      this.status = 'OFF'
    }
    
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: black;
  color: white;
  font-family: "Turret Road", cursive;
  padding: 5em 4em;
  display: grid;
  justify-content: center;

  .title {
    font-size: 300%;
  }

  .title1 {
    font-size: 150%;
  }

  .wrapper {
    display: grid;
    grid-gap: 2em;
  }

  .flexbox {
    display: flex;
    align-items: center;
    gap: 1em;

    img {
      width: 100px;
    }
  }

  .gridbox {
    display: grid;
    grid-gap: 3em;
    grid-template-columns: repeat(auto-fit,minmax(200px,1fr));
    justify-content: space-around;
    align-items: center;

    .box {
      display: grid;
      grid-gap: 1em;
      justify-content: space-around;

      .content {
        text-align: center;
        letter-spacing: 2px;
      }
    }
  }
}

@media (max-width: 650px) {
  .wrapper {

    .flexbox {
      .title {
        font-size: 200%;
      }

      img {
        width: 50px;
      }
    }
    .content {
      .gridbox {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      }
    }
  }
}

@media (max-width: 450px) {
  .wrapper {

    .flexbox {
      .title {
        font-size: 150%;
      }
      img {
        width: 50px;
      }
    }
  
  }
}
</style>